import { createFileRoute, Navigate } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/_authenticated/_organization/communication/announcements/$announcementUuid/"
)({
  component: function AnnouncementDetailIndexRoute() {
    const { announcementUuid } = Route.useParams()
    return (
      <Navigate
        to="/communication/announcements/$announcementUuid/$tabKey"
        params={{ announcementUuid, tabKey: "details" }}
        replace
      />
    )
  },
})
